






























































































import TcSolicitingInput from '@telia/tc-soliciting-input'
import { TcButton, TcPageAlert } from '@telia/shared-ui-components'

import debounce from 'lodash/debounce'

import {
  defineComponent,
  ref,
  computed,
  onUnmounted
} from '@vue/composition-api'

import { AnslLink } from '@/components/common'

import AnslSpinner from '../LoadingSpinner.vue'

import { Getters, Actions } from '@/store/modules/address-search.store'
import {
  accessorFactory,
  Namespace
} from '@/store'

import { Address } from '@/types/area-response.types'

import { RoutePath as routes } from '@/router'
import { CfAnslAddressSearch } from '@/types/ansl-space/types/cf-ansl-address-search'
import { Entry } from 'contentful'
interface Option {
  label: string;
  value: Address;
}

const {
  fetchContent: fetchAddressSearchContent,
  getContent: getAddressSearchContent
} = accessorFactory<Entry<CfAnslAddressSearch>>(Namespace.AddressSearchContent)

export default defineComponent({
  props: {
    isParentComponentBusy: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AnslLink,
    AnslSpinner,
    TcSolicitingInput,
    TcButton,
    TcPageAlert
  },
  setup (props, context) {
    const store = context.root.$store

    const searchString = ref<string>('')

    const addressOptions = computed(() => Getters.getAddresses(store).map(address => ({
      label: `${address.FullAddress} ${address.City}`,
      value: address
    })))

    const apartments = computed(() => Getters.getApartments(store))

    const apartmentOptions = computed(() => apartments.value.map(apartment => ({
      addressId: apartment.AddressId,
      url: apartment.RedirectUrl,
      title: apartment.ApartmentNumber,
      isLoading: false
    })))

    const selectedAddress = computed<Address | null>({
      get: () => Getters.getSelectedAddress(store),
      set: (address: Address | null) => Actions.updateSelectedAddress(store, address)
    })

    const isLoading = computed<boolean>(() => Getters.isLoading(store))

    const isSearchDisabled = computed(() => !selectedAddress.value || apartmentOptions.value.length > 1)

    const noOptionsMessage = computed(() => {
      if (searchString.value.length > 3 && addressOptions.value.length === 0 && !isLoading.value) {
        return 'Vi hittar ingen matchande adress'
      }
      return null
    })

    const fetchAddressesDebounced = debounce(
      (input: string) => Actions.fetchAddresses(store, input),
      1000
    )

    const handleSearchStringChange = (input: string) => {
      Actions.clearAddresses(store)

      searchString.value = input

      if (input.length > 3) {
        Actions.searchStringChanged(store)

        fetchAddressesDebounced(input)
      } else {
        Actions.searchCanceled(store)

        fetchAddressesDebounced.cancel()
      }
    }

    const handleSelect = (input: Option) => {
      selectedAddress.value = input.value
      searchString.value = input.label

      Actions.fetchApartments(store)
    }

    const handleSubmit = () => {
      if (props.isParentComponentBusy || isSearchDisabled.value) {
        return
      }

      context.emit('addressSelected', { ...selectedAddress.value, ...apartments.value[0] })
    }

    const handleApartmentSelect = (optionIndex: number) => {
      if (props.isParentComponentBusy) {
        return
      }

      // Makes apartment spinner appear
      apartmentOptions.value.forEach((option, index) => {
        option.isLoading = index === optionIndex
      })

      context.emit('addressSelected', { ...selectedAddress.value, ...apartments.value[optionIndex] })
    }

    fetchAddressSearchContent(store)
    const addressSearchContent = computed(() => getAddressSearchContent(store))
    const showInfoAlert = computed(() => addressSearchContent.value?.fields.showInfoAlert)
    const infoAlert = computed(() => addressSearchContent.value?.fields.infoAlert)

    onUnmounted(() => {
      Actions.clearAddresses(store)
    })

    return {
      searchString,
      addressOptions,
      apartmentOptions,
      handleSearchStringChange,
      handleSelect,
      handleSubmit,
      handleApartmentSelect,
      isSearchDisabled,
      noOptionsMessage,
      isLoading,
      routes,
      showInfoAlert,
      infoAlert
    }
  }
})
